import React, { FC } from "react";

export interface TokenBalance {
    token: {
        mint: string,
        name: string,
        symbol: string,
        image?: string,
    },
    amount: string;
    at: string;
}

export type ListTokenBalanceProps = {
    token: Array<TokenBalance>;
}

export const ListTokenBalance: FC<ListTokenBalanceProps> = ({ token }) => {
    return (
        <div className="space-y-2 max-h-80 overflow-y-auto pr-1 backdrop-blur-md">
            {token.map((twa) => {
                const token = twa.token;
                const amount = twa.amount;

                return (
                    <button
                        key={token.mint}
                        // onClick={() => onSelect(twa)}
                        className="flex items-center w-full px-4 py-3 rounded-xl border border-yellow-500 hover:border-orange-300 hover:bg-orange-50 transition text-left"
                    >
                        {token.image ? (
                            <img
                                src={token.image}
                                alt={token.symbol}
                                className="h-8 w-8 rounded-full mr-3 border border-orange-200"
                            />
                        ) : (
                            <div
                                className="h-8 w-8 rounded-full mr-3 bg-orange-200 text-orange-800 flex items-center justify-center font-bold text-sm border border-orange-300">
                                {token.symbol.charAt(0)}
                            </div>
                        )}

                        <div className="flex-1">
                            <div className="text-sm font-semibold text-orange-200">{token.name}</div>
                            <div className="text-xs text-gray-500">{token.symbol}</div>
                        </div>

                        <div className="text-sm font-mono text-orange-200">
                            {/*{amount.toFixed(4)}*/}
                            {amount}
                        </div>
                    </button>
                );
            })}

            {token.length === 0 && (
                <div className="text-center text-sm text-orange-400 py-4">
                    No tokens found
                </div>
            )}
        </div>
    );
};
